import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { MainColors } from '../constants/Colors';
import FontSizes from '../constants/FontSizes';

const CheckBox = (props) => {
    return (
        <View style={styles.container}>
            <TouchableOpacity onPress={props.onPress}>
                <Icon
                    size={24}
                    color={MainColors.primary}
                    name={props.isChecked ? 'check-box' : 'check-box-outline-blank'}
                />
            </TouchableOpacity>
            <Text style={styles.checkboxText} onPress={props.onPress}>{props.checkboxText}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 30,
        marginBottom: 5
    },
    checkboxText: {
        marginLeft: 5,
        fontSize: FontSizes.medium,
        color: MainColors.darkGray
    }
});

export default CheckBox;